'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _roles = require('config/permissions/roles');

var _ingredientRisk = require('./ingredient-risk.component');

var _ingredientRisk2 = _interopRequireDefault(_ingredientRisk);

var _ingredientRisk3 = require('./ingredient-risk.service');

var _ingredientRisk4 = _interopRequireDefault(_ingredientRisk3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.reports.ingredient-risk', [_angularUiRouter2.default]).component('ingredientRiskReport', _ingredientRisk2.default).service('IngredientRiskService', _ingredientRisk4.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('ingredientRisk', {
    parent: 'reports',
    url: '/ingredient-risk',
    component: 'ingredientRiskReport',
    data: {
      permissions: {
        only: [_roles.SYS_ADMIN],
        redirectTo: 'dashboard'
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/app/reports/ingredient-risk/ingredient-risk.module.js